import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { fmtINR, fmtDate, san, loadLogoDataUrl, drawITOHeader, resolveBrandName } from "./common";

export async function generateInvoicePdf(inv, company) {
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  const logo = await loadLogoDataUrl();
  let y = drawITOHeader(doc, company, logo, "TAX INVOICE", resolveBrandName(inv, company), "TRANSPORT DIVISION  |  TAX INVOICE");

  doc.setFontSize(10);
  doc.setFont("helvetica","bold"); doc.text("Invoice No:", 12, y); doc.setFont("helvetica","normal"); doc.text(String(inv.invoice_number || ""), 36, y);
  doc.setFont("helvetica","bold"); doc.text("Date:", 110, y); doc.setFont("helvetica","normal"); doc.text(fmtDate(inv.invoice_date), 124, y);
  if (inv.due_date) { doc.setFont("helvetica","bold"); doc.text("Due:", 160, y); doc.setFont("helvetica","normal"); doc.text(fmtDate(inv.due_date), 172, y); }
  y += 4;

  autoTable(doc, {
    startY: y, theme: "grid", styles: { fontSize: 9, cellPadding: 2 },
    headStyles: { fillColor: [240, 240, 240], textColor: 40, fontStyle: "bold" },
    head: [["Bill To"]],
    body: [[`${san(inv.customer_name)}\n${san(inv.customer_address) || ""}${inv.customer_attn ? `\nKind Attn: ${san(inv.customer_attn)}` : ""}\nGST: ${inv.customer_gst || "-"}`]],
  });
  y = doc.lastAutoTable.finalY + 3;

  const body = (inv.items || []).map((it, i) => [String(i + 1), san(it.description), String(it.quantity), fmtINR(it.rate), fmtINR(it.amount)]);
  autoTable(doc, {
    startY: y, theme: "grid", styles: { fontSize: 9, cellPadding: 2.5 },
    headStyles: { fillColor: [200, 30, 30], textColor: 255, fontStyle: "bold" },
    head: [["#", "Description", "Qty", "Rate", "Amount"]],
    body: body.length ? body : [["", "—", "", "", ""]],
    columnStyles: { 0: { cellWidth: 10 }, 2: { halign: "right", cellWidth: 18 }, 3: { halign: "right", cellWidth: 28 }, 4: { halign: "right", cellWidth: 32 } },
  });
  y = doc.lastAutoTable.finalY + 4;

  doc.setFontSize(10);
  doc.text("Subtotal:", 158, y, { align: "right" }); doc.text(fmtINR(inv.subtotal), 196, y, { align: "right" }); y += 6;
  const isRcm = inv.gst_mode === "rcm";
  if (Number(inv.gst_amount || 0) > 0) {
    doc.text(isRcm ? `GST (${inv.gst_percent}%) [RCM]:` : `GST (${inv.gst_percent}%):`, 158, y, { align: "right" });
    doc.text(fmtINR(inv.gst_amount), 196, y, { align: "right" }); y += 6;
  }
  doc.setFont("helvetica","bold"); doc.setFontSize(12);
  doc.text(isRcm ? "TOTAL (excl. GST):" : "TOTAL:", 158, y, { align: "right" }); doc.text(fmtINR(inv.total), 196, y, { align: "right" });
  y += 8;
  if (isRcm) {
    doc.setFont("helvetica","normal"); doc.setFontSize(8); doc.setTextColor(120);
    doc.text(doc.splitTextToSize("GST payable by the recipient under Reverse Charge Mechanism (RCM) as per Notification No. 13/2017-Central Tax (Rate). The above GST amount is NOT collected by us.", 184), 12, y);
    doc.setTextColor(0); y += 10;
  } else {
    y += 4;
  }

  if (company?.bank_name || company?.bank_account) {
    doc.setFont("helvetica","bold"); doc.setFontSize(9); doc.text("Bank Details", 12, y); y += 5;
    doc.setFont("helvetica","normal");
    if (company.bank_name) { doc.text("Bank: " + company.bank_name, 12, y); y += 4; }
    if (company.bank_account) { doc.text("A/C: " + company.bank_account, 12, y); y += 4; }
    if (company.bank_ifsc) { doc.text("IFSC: " + company.bank_ifsc, 12, y); y += 4; }
  }

  if (inv.notes) {
    y += 2;
    doc.setFont("helvetica","bold"); doc.text("Notes:", 12, y);
    doc.setFont("helvetica","normal");
    doc.text(doc.splitTextToSize(san(inv.notes), 186), 12, y + 5);
  }

  doc.setFont("helvetica","bold"); doc.setFontSize(8);
  doc.text("All Subject to Mumbai Jurisdiction Only", 105, 268, { align: "center" });
  doc.setFont("helvetica","normal");
  doc.text("For " + resolveBrandName(inv, company), 196, 278, { align: "right" });
  doc.text("Authorised Signatory", 196, 285, { align: "right" });

  doc.save(`Invoice-${inv.invoice_number || "draft"}.pdf`);
}
